import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

export const usePostSplashScreen = () => {
  const { authHeader } = useAuth();

  return useMutation(({ params }: { params }) => {
    return axios.post(
      `${env.verifyServiceUrl}individual/splash_screen/`,
      params,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
